
import React from "react";
import { cn } from "@/lib/utils";

const SkipToContent: React.FC = () => {
  return (
    <a
      href="#main-content"
      className={cn(
        "sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4",
        "z-50 bg-white text-black px-4 py-2 rounded-md border-2 border-black",
        "focus:outline-none focus:ring-2 focus:ring-blue-500"
      )}
    >
      Skip to main content
    </a>
  );
};

export default SkipToContent;
